__turbopack_context__.v({
  "Borders": "Text2Columns-module-sass-module__Lb8miq__Borders",
  "Cont": "Text2Columns-module-sass-module__Lb8miq__Cont",
  "CopyCont": "Text2Columns-module-sass-module__Lb8miq__CopyCont",
  "Dark": "Text2Columns-module-sass-module__Lb8miq__Dark",
  "ImageSection": "Text2Columns-module-sass-module__Lb8miq__ImageSection",
  "IntroCopy": "Text2Columns-module-sass-module__Lb8miq__IntroCopy",
  "Main": "Text2Columns-module-sass-module__Lb8miq__Main",
  "MainIntro": "Text2Columns-module-sass-module__Lb8miq__MainIntro",
  "Reverse": "Text2Columns-module-sass-module__Lb8miq__Reverse",
  "ReverseMain": "Text2Columns-module-sass-module__Lb8miq__ReverseMain",
  "Text2Columns": "Text2Columns-module-sass-module__Lb8miq__Text2Columns",
  "VideoSection": "Text2Columns-module-sass-module__Lb8miq__VideoSection",
  "White": "Text2Columns-module-sass-module__Lb8miq__White",
});
